module.exports = __webpack_public_path__ + "img/beer_id-115.808fbcc2.png";